<div id="main-wrapper">
  <div class="site-wrapper-reveal">
    <div class="position-relative w-100">
      <div class="d-flex align-items-center w-100">

        <img src="../../../assets/images/banners/staffing-process-banner.png"
          class="img img-responsive w-100 h-100 d-none d-md-block" width="100%" alt="Mobile Service Banner" />

        <img src="../../../assets/images/banners/staffing-process-mobilebanner.png"
          class="img img-responsive d-block d-md-none" width="100%" alt="Mobile Application Banner" />
        <div class="position-absolute w-100 home-banner">
          <div class="row h-100 w-100">
            <div class="col-8 col-md-6 col-sm-6 banner-section">
              <div
                class="align-items-center banner-content-title global_title global_banner_title title_banner_content .adjust-font-size"
                role="heading" aria-level="1">
                <span>Our Staffing Process </span>
              </div>
              <div class="global_sub_title global_banner_subtitle mt-3 text-white" role="heading" aria-level="1">
                <span>Gain quick access to purpose-driven professionals who fit your role, your culture, and your mission.</span>
              </div>
             
              <div class="col pt-lg-3 pt-3 mt-lg-3">
                <a href="contact" class="global_button   text-left col  text-white white_button" role="button"
                  aria-label="View Contact Page" tabindex="0">
                  <div class="dub-arrow"><img src="../../../assets/images/button/arrowWhite.png"
                      alt="Contact to Explore" /></div>
                  TALK TO OUR EXPERT
                </a>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class=" banner-subsection col">
             <h5>Trusted by Global Technology companies</h5>
             </div> -->
  </div>
</div>

<div class="container">
  <div class="row py-2 py-lg-4">
    <div class="col-12 col-md-6 col-lg-3 btn-group">
      <a (click)="scrollToSection('introduction')" class="btn" role="button">Introduction</a>
    </div>
    <div class="col-12 col-md-6 col-lg-3 btn-group">
      <a (click)="scrollToSection('ourstaffing')" class="btn" role="button">Our Staffing Process</a>
    </div>
    <div class="col-12 col-md-6 col-lg-3 btn-group">
      <a (click)="scrollToSection('whychoose')" class="btn" role="button">Why us</a>
    </div>
    <div class="col-12 col-md-6 col-lg-3 btn-group">
      <a (click)="scrollToSection('faq')" class="btn" role="button">FAQ</a>
    </div>
  </div>
</div>

<div class="bg_color position-relative " id="introduction">
  <div class="container hire-precision-cont py-4 py-lg-5">
    <div class="row">
      <div class="col-md-6 mb-md-0 m-0 ps-3 ps-md-0">
        <div class="fw-semibold h2 text_head border-left ps-3">
         Achieve success with a high-performance hiring process that's built for real-world demands
        </div>
      </div>
      <div class="col-md-6">
        <p class="global_section_content">
          Talent gaps are business risks. And traditional staffing models are too slow or too shallow to fix them. 
        </p>
        <p class="global_section_content">
          Our model is built for speed and accuracy. Through structured vetting, contextual role alignment, and a ready supply of qualified professionals, we close those gaps within 24 hours. You gain speed, precision, and impact without compromise. 
        </p>
      </div>
    </div>
  </div>
</div>


<div class="container text-center my-5 mb-lg-0 mb-md-0 position-relative" id="ourstaffing">
  <div class="h2 text_head">How Our Staffing Process Works</div>
</div>

<div class="circular-wrapper">
  <div class="dashed-circle"></div>


  <div class="center-image"><img src="../../../assets/images/staffing-process/image (46).png" alt="Center"
      class="zoom-img" /></div>


  <div class="step top-center custom-right-align" (click)="scrollToSection('Recruitment')">Recruitment Requisition &
    Role Discovery</div>
  <div class="step top-right" (click)="scrollToSection('Resume')">Resume Screening & Talent Shortlisting</div>
  <div class="step mid-upper-right" (click)="scrollToSection('Phone')">Phone Assessment</div>
  <div class="step mid-right" (click)="scrollToSection('Technical')">Technical & Functional Evaluation</div>
  <div class="step lower-mid-right" (click)="scrollToSection('Behavioral')">Behavioral Assessment</div>
  <div class="step bottom-center" (click)="scrollToSection('Behavioral')">Cultural Fit Assessment</div>
  <div class="step lower-mid-left" (click)="scrollToSection('Additional')">Additional Assessment</div>
  <div class="step mid-left" (click)="scrollToSection('Reference')">Reference & Background Check</div>
  <div class="step mid-upper-left" (click)="scrollToSection('Final')">Final Interview & Negotiation</div>
  <div class="step top-left" (click)="scrollToSection('Onboarding')">Onboarding & Client Feedback</div>
</div>


<div class="bg_color position-relative" id="Recruitment">
  <div class="container-fluid textmedia-padding px-2 px-md-4 px-lg-5 px-xl-0">
    <div class="row g-0 align-items-center overflow-hidden py-3 py-lg-5">
      <!-- Image with Overlay -->
      <div class="col-lg-5 col-xl-4  d-flex justify-content-center">
        <div class="image-section" (mouseenter)="hover = true" (mouseleave)="hover = false">
          <img src="../../../assets/images/staffing-process/image (13).jpg"
            class="img-fluid w-100 h-100 object-fit-cover" alt="Team working" />

          <!-- Overlay and Text inside image -->
          <div class="overlay" [ngClass]="{ 'show': hover }"></div>
          <div class="overlay-text img_text" [ngClass]="{ 'show': hover }">
            We start by understanding what success means to you. </div>
        </div>
      </div>

      <!-- Text section -->
      <div class="col-lg-7 col-xl-8 ps-lg-5 bg-light pt-3 ps-0 py-lg-3 pe-lg-5 ">
        <div class=" mb-4 mt-1 h2 text_head lh ">Recruitment Requisition & Role Discovery</div>
        <p class="global_section_content  mb-2">
        Every great hire starts with asking the right questions. We work with you to understand the role’s scope, required skills, and success metrics. This keeps the recruitment process focused, efficient, and aligned with your goals.
        </p>

        <ul class="list-unstyled mt-3 custom-list">
          <li class="d-flex mb-2 global_section_content">
            <span class="icon-wrapper me-2">
              <svg viewBox="0 0 24 24" width="18" height="18">
                <circle cx="12" cy="12" r="10" fill="#228BE6" />
                <path d="M7 12.5l3 3.2 7-7" stroke="white" stroke-width="2" fill="none" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </span>
            Conduct a formal intake meeting with stakeholders
          </li>

          <li class="d-flex mb-2 global_section_content">
            <span class="icon-wrapper me-2">
              <svg viewBox="0 0 24 24" width="18" height="18">
                <circle cx="12" cy="12" r="10" fill="#228BE6" />
                <path d="M7 12.5l3 3.2 7-7" stroke="white" stroke-width="2" fill="none" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </span>
            Define job responsibilities, required tech stacks, project context
          </li>

          <li class="d-flex mb-2 global_section_content">
            <span class="icon-wrapper me-2 ">
              <svg viewBox="0 0 24 24" width="18" height="18">
                <circle cx="12" cy="12" r="10" fill="#228BE6" />
                <path d="M7 12.5l3 3.2 7-7" stroke="white" stroke-width="2" fill="none" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </span>
            Capture soft skills, domain preferences, and cultural nuances
          </li>

          <li class="d-flex mb-2 global_section_content">
            <span class="icon-wrapper me-2">
              <svg viewBox="0 0 24 24" width="18" height="18">
                <circle cx="12" cy="12" r="10" fill="#228BE6" />
                <path d="M7 12.5l3 3.2 7-7" stroke="white" stroke-width="2" fill="none" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </span>
            Lock interview stages, timelines, urgency, and budget
          </li>

          <li class="d-flex mb-2 global_section_content">
            <span class="icon-wrapper me-2">
              <svg viewBox="0 0 24 24" width="18" height="18">
                <circle cx="12" cy="12" r="10" fill="#228BE6" />
                <path d="M7 12.5l3 3.2 7-7" stroke="white" stroke-width="2" fill="none" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </span>
            Advise on hiring feasibility and market insights
          </li>
        </ul>
      </div>

    </div>
  </div>
</div>

<!-- Resume Screening & Talent Shortlisting -->
<div class="" id="Resume">
  <div class="container-fluid textmedia-padding px-2 px-md-4 px-lg-5 px-xl-0">
    <div class="row g-0 align-items-center  overflow-hidden flex-row-reverse py-3 py-lg-5">
      <div class="col-lg-5 col-xl-4 d-flex justify-content-center">
        <div class="image-section" (mouseenter)="hover1 = true" (mouseleave)="hover1 = false">
          <img src="../../../assets/images/staffing-process/image (8).jpg"
            class="img-fluid w-100 h-100 object-fit-cover" alt="Team working" />

          <div class="overlay" [ngClass]="{ 'show': hover1 }"></div>
          <div class="overlay-text img_text" [ngClass]="{ 'show': hover1 }">
            We go beyond keywords-so your resume meets the role, not just the algorithm. </div>
        </div>
      </div>

      <!-- Text section -->
      <div class="col-lg-7 col-xl-8 pt-3 ps-0 py-lg-3 pe-lg-5">
        <div class=" mb-4 mt-1 h2 text_head"> Resume Screening & Talent Shortlisting </div>
        <p class="global_section_content mb-2">
        We go beyond keywords to assess whether the skills are relevant, the experience is consistent, and the background fits your domain. We evaluate technical alignment, communication ability, and availability to ensure you only see candidates who are ready, committed, and worth your time.
        </p>
        <ul class="list-unstyled mt-3 custom-list">
          <li class="d-flex mb-2 global_section_content">
            <span class="icon-wrapper me-2">
              <svg class="check-icon" viewBox="0 0 24 24">
                <circle cx="12" cy="12" r="10" fill="#228BE6" />
                <path d="M7 12.5l3 3.2 7-7" stroke="white" stroke-width="2" fill="none" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </span>
            Tap into internal talent bench, referrals, and external sourcing
          </li>
          <li class="d-flex mb-2 global_section_content">
            <span class="icon-wrapper me-2">
              <svg class="check-icon" viewBox="0 0 24 24">
                <circle cx="12" cy="12" r="10" fill="#228BE6" />
                <path d="M7 12.5l3 3.2 7-7" stroke="white" stroke-width="2" fill="none" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </span>
            Filter profiles based on skill fit, stability, location, and notice period
          </li>
          <li class="d-flex mb-2 global_section_content">
            <span class="icon-wrapper me-2">
              <svg class="check-icon" viewBox="0 0 24 24">
                <circle cx="12" cy="12" r="10" fill="#228BE6" />
                <path d="M7 12.5l3 3.2 7-7" stroke="white" stroke-width="2" fill="none" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </span>
            Cross-match against current project/team requirements
          </li>
          <li class="d-flex mb-2 global_section_content">
            <span class="icon-wrapper me-2">
              <svg class="check-icon" viewBox="0 0 24 24">
                <circle cx="12" cy="12" r="10" fill="#228BE6" />
                <path d="M7 12.5l3 3.2 7-7" stroke="white" stroke-width="2" fill="none" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </span>
            Review resumes for both hard skills and trajectory
          </li>
        </ul>
      </div>

    </div>
  </div>
</div>

<!-- Initial Phone/Video Assessment -->
<div class="bg_color position-relative " id="Phone">
  <div class="container-fluid textmedia-padding px-2 px-md-4 px-lg-5 px-xl-0">
    <div class="row g-0 align-items-center  overflow-hidden py-3 py-lg-5">
      <!-- Image with Overlay -->
      <div class="col-lg-5 col-xl-4 d-flex justify-content-center">
        <div class="image-section" (mouseenter)="hover2 = true" (mouseleave)="hover2 = false">
          <img src="../../../assets/images/staffing-process/image (9).jpg"
            class="img-fluid w-100 h-100 object-fit-cover img-position2" alt="Team working" />

          <!-- Overlay and Text inside image -->
          <div class="overlay" [ngClass]="{ 'show': hover2 }"></div>
          <div class="overlay-text img_text" [ngClass]="{ 'show': hover2 }">
            Save time with candidates who match expectations from the first conversation. </div>
        </div>
      </div>

      <!-- Text section -->
      <div class="col-lg-7 col-xl-8 pt-3 p-lg-3 ps-lg-5 bg-light">
        <div class=" mb-4 mt-1 h2 text_head">Initial Phone/Video Assessment</div>
        <p class="global_section_content mb-2">
        Before any candidate reaches your team, we speak with them directly through structured phone or video interviews. We assess their communication, professionalism, and genuine interest in the role. We also confirm key details like availability, compensation expectations, and cultural fit.
        </p>
        <ul class="list-unstyled mt-3 custom-list">
          <li class="d-flex mb-2 global_section_content">
            <span class="icon-wrapper me-2">
              <svg class="check-icon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="10" fill="#228BE6" />
                <path d="M7 12.5l3 3.2 7-7" stroke="white" stroke-width="2" fill="none" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </span>
            Conduct phone or Zoom screening using structured questions
          </li>
          <li class="d-flex mb-2 global_section_content">
            <span class="icon-wrapper me-2">
              <svg class="check-icon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="10" fill="#228BE6" />
                <path d="M7 12.5l3 3.2 7-7" stroke="white" stroke-width="2" fill="none" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </span>
            Validate communication clarity and ability to articulate experience
          </li>
          <li class="d-flex mb-2 global_section_content">
            <span class="icon-wrapper me-2">
              <svg class="check-icon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="10" fill="#228BE6" />
                <path d="M7 12.5l3 3.2 7-7" stroke="white" stroke-width="2" fill="none" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </span>
            Confirm availability, work authorization, relocation, and salary expectations
          </li>
          <li class="d-flex mb-2 global_section_content">
            <span class="icon-wrapper me-2">
              <svg class="check-icon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="10" fill="#228BE6" />
                <path d="M7 12.5l3 3.2 7-7" stroke="white" stroke-width="2" fill="none" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </span>
            Assess motivation, professionalism, and initial fit
          </li>
        </ul>
      </div>


    </div>
  </div>
</div>

<!-- Technical + Behavioral + Cultural Assessment -->
<div class="" id="Technical">
  <div class="container-fluid textmedia-padding px-2 px-md-4 px-lg-5 px-xl-0">
    <div class="row g-0 align-items-center  overflow-hidden flex-row-reverse py-3 py-lg-5">
      <div class="col-lg-5 col-xl-4 d-flex justify-content-center">
        <div class="image-section " (mouseenter)="hover3 = true" (mouseleave)="hover3 = false">
          <img src="../../../assets/images/staffing-process/image (20).jpg"
            class="img-fluid w-100 h-100 object-fit-cover  img-position1" alt="Team working" />

          <div class="overlay" [ngClass]="{ 'show': hover3 }"></div>
          <div class="overlay-text img_text" [ngClass]="{ 'show': hover3 }">
            Make hiring decisions backed by data, not guesswork. </div>
        </div>
      </div>

      <!-- Text section -->
      <div class="col-lg-7 col-xl-8 pt-3 ps-0 py-lg-3 pe-lg-5">
        <div class=" mb-4 mt-1 h2 text_head">Technical & Functional Evaluation</div>
        <p class="global_section_content mb-2">
        Candidates are evaluated on your tech stack and real-world challenges, whether that involves live coding, system design, or architecture tasks. We focus on how they think and solve problems. Every result is reviewed by senior technical leads to ensure they are capable, confident, and ready to contribute from day one.
        </p>
        <ul class="list-unstyled mt-3 custom-list">
          <li class="d-flex mb-2 global_section_content">
            <span class="icon-wrapper me-2">
              <svg class="check-icon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="10" fill="#228BE6" />
                <path d="M7 12.5l3 3.2 7-7" stroke="white" stroke-width="2" fill="none" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </span>
            Assign online tests, coding tasks, system design, or role simulations
          </li>
          <li class="d-flex mb-2 global_section_content">
            <span class="icon-wrapper me-2">
              <svg class="check-icon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="10" fill="#228BE6" />
                <path d="M7 12.5l3 3.2 7-7" stroke="white" stroke-width="2" fill="none" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </span>
            Use platforms like HackerRank, Codility, or our in-house SMEs
          </li>
          <li class="d-flex mb-2 global_section_content">
            <span class="icon-wrapper me-2">
              <svg class="check-icon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="10" fill="#228BE6" />
                <path d="M7 12.5l3 3.2 7-7" stroke="white" stroke-width="2" fill="none" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </span>
            Score against predefined technical benchmarks
          </li>
          <li class="d-flex mb-2 global_section_content">
            <span class="icon-wrapper me-2">
              <svg class="check-icon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="10" fill="#228BE6" />
                <path d="M7 12.5l3 3.2 7-7" stroke="white" stroke-width="2" fill="none" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </span>
            Apply role-specific grading rubrics
          </li>
        </ul>
      </div>

    </div>
  </div>
</div>

<!-- Reference & Background Verification -->
<div class="bg_color position-relative " id="Behavioral">
  <div class="container-fluid textmedia-padding px-2 px-md-4 px-lg-5 px-xl-0">
    <div class="row g-0 align-items-center  overflow-hidden py-3 py-lg-5">
      <!-- Image with Overlay -->
      <div class="col-lg-5 col-xl-4
  d-flex justify-content-center">
        <div class="image-section" (mouseenter)="hover4 = true" (mouseleave)="hover4 = false">
          <img src="../../../assets/images/staffing-process/image (12).png"
            class="img-fluid w-100 h-100 object-fit-cover" alt="Team working" />

          <!-- Overlay and Text inside image -->
          <div class="overlay" [ngClass]="{ 'show': hover4 }"></div>
          <div class="overlay-text img_text" [ngClass]="{ 'show': hover4 }">
            Reduce turnover with hires who align with your culture and goals. </div>
        </div>
      </div>

      <!-- Text section -->
      <div class="col-lg-7 col-xl-8 pt-3 p-lg-3 ps-lg-5 bg-light">
        <div class=" mb-4 mt-1 h2 text_head">Behavioral & Cultural Assessment</div>
        <p class="global_section_content mb-2">
         It is not just about what candidates know. It is about how they think, adapt, and collaborate. Our structured interviews reveal how they communicate, solve problems, and align with your team, ensuring every hire brings the right mix of skill and mindset. 
        </p>
        <ul class="list-unstyled mt-3 custom-list">
          <li class="d-flex mb-2 global_section_content">
            <span class="icon-wrapper me-2">
              <svg class="check-icon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="10" fill="#228BE6" />
                <path d="M7 12.5l3 3.2 7-7" stroke="white" stroke-width="2" fill="none" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </span>
            Use STAR framework to evaluate mindset and adaptability
          </li>
          <li class="d-flex mb-2 global_section_content">
            <span class="icon-wrapper me-2">
              <svg class="check-icon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="10" fill="#228BE6" />
                <path d="M7 12.5l3 3.2 7-7" stroke="white" stroke-width="2" fill="none" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </span>
            Assess fit for client-specific communication norms and team dynamics
          </li>
          <li class="d-flex mb-2 global_section_content">
            <span class="icon-wrapper me-2">
              <svg class="check-icon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="10" fill="#228BE6" />
                <path d="M7 12.5l3 3.2 7-7" stroke="white" stroke-width="2" fill="none" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </span>
            Flag risks (rigid behavior, overconfidence, coachability concerns)
          </li>
          <li class="d-flex mb-2 global_section_content">
            <span class="icon-wrapper me-2">
              <svg class="check-icon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="10" fill="#228BE6" />
                <path d="M7 12.5l3 3.2 7-7" stroke="white" stroke-width="2" fill="none" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </span>
            Evaluate potential for leadership or cross-functional impact
          </li>
        </ul>
      </div>

    </div>
  </div>
</div>

<!-- Additional Assessment -->
<div class="" id="Reference">
  <div class="container-fluid textmedia-padding px-2 px-md-4 px-lg-5 px-xl-0">
    <div class="row g-0 align-items-center  overflow-hidden flex-row-reverse py-3 py-lg-5">
      <div class="col-lg-5 col-xl-4
 d-flex justify-content-center">
        <div class="image-section" (mouseenter)="hover5 = true" (mouseleave)="hover5 = false">
          <img src="../../../assets/images/staffing-process/image (19).jpg"
            class="img-fluid w-100 h-100 object-fit-cover" alt="Team working" />

          <div class="overlay" [ngClass]="{ 'show': hover5 }"></div>
          <div class="overlay-text img_text" [ngClass]="{ 'show': hover5 }">
            From character to compliance, we verify what matters-so you don’t have to second-guess. </div>
        </div>
      </div>

      <!-- Text section -->
      <div class="col-lg-7 col-xl-8 pt-3 ps-0 py-lg-3 pe-lg-5">
        <div class=" mb-4 mt-1 h2 text_head">Reference & Background Verification</div>
        <p class="global_section_content mb-2">
         Before you make the final decision, we ensure every detail is verified. References, work history, education, and background checks are all confirmed based on the role and location. You receive clear, trusted insights to support informed and confident hiring decisions.
        </p>
        <ul class="list-unstyled mt-3 custom-list">
          <li class="d-flex mb-2 global_section_content">
            <span class="icon-wrapper me-2">
              <svg class="check-icon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="10" fill="#228BE6" />
                <path d="M7 12.5l3 3.2 7-7" stroke="white" stroke-width="2" fill="none" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </span>
            Speak directly with past supervisors or team leads
          </li>
          <li class="d-flex mb-2 global_section_content">
            <span class="icon-wrapper me-2">
              <svg class="check-icon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="10" fill="#228BE6" />
                <path d="M7 12.5l3 3.2 7-7" stroke="white" stroke-width="2" fill="none" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </span>
            Run employment and education verification
          </li>
          <li class="d-flex mb-2 global_section_content">
            <span class="icon-wrapper me-2">
              <svg class="check-icon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="10" fill="#228BE6" />
                <path d="M7 12.5l3 3.2 7-7" stroke="white" stroke-width="2" fill="none" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </span>
            Initiate criminal background checks (as applicable by role)
          </li>
          <li class="d-flex mb-2 global_section_content">
            <span class="icon-wrapper me-2">
              <svg class="check-icon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="10" fill="#228BE6" />
                <path d="M7 12.5l3 3.2 7-7" stroke="white" stroke-width="2" fill="none" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </span>
            Detailed verification is completed post-project confirmation, in accordance with legal requirements
          </li>
        </ul>
      </div>

    </div>
  </div>
</div>

<!-- Final Interview Coordination & Offer Management -->
<div class="bg_color position-relative " id="Additional">
  <div class="container-fluid textmedia-padding px-2 px-md-4 px-lg-5 px-xl-0">
    <div class="row g-0 align-items-center  overflow-hidden py-3 py-lg-5">
      <!-- Image with Overlay -->
      <div class="col-lg-5 col-xl-4
 d-flex justify-content-center">
        <div class="image-section" (mouseenter)="hover6 = true" (mouseleave)="hover6 = false">
          <img src="../../../assets/images/staffing-process/image (2).jpeg"
            class="img-fluid w-100 h-100 object-fit-cover" alt="Team working" />

          <!-- Overlay and Text inside image -->
          <div class="overlay" [ngClass]="{ 'show': hover6 }"></div>
          <div class="overlay-text img_text" [ngClass]="{ 'show': hover6 }">
            When core screening isn’t enough, we go deeper. </div>
        </div>
      </div>

      <!-- Text section -->
      <div class="col-lg-7 col-xl-8 pt-3 p-lg-3 ps-lg-5 bg-light">
        <div class=" mb-4 mt-1 h2 text_head">Additional Assessment</div>
        <p class="global_section_content mb-2">
        Some roles require sharper thinking, domain expertise, or leadership potential. Our Additional Assessment step adds an extra layer through tailored evaluations such as cognitive tests, domain-specific simulations, and leadership profiling. This ensures you hire candidates who exceed expectations, not just meet them.
        </p>
        <ul class="list-unstyled mt-3 custom-list">
          <li class="d-flex align-items-start mb-2 global_section_content">
            <span class="icon-wrapper me-2">
              <svg class="check-icon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="10" fill="#228BE6" />
                <path d="M7 12.5l3 3.2 7-7" stroke="white" stroke-width="2" fill="none" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </span>
            Customize assessments based on leadership, analytical, or industry-specific criteria
          </li>
          <li class="d-flex align-items-start mb-2 global_section_content">
            <span class="icon-wrapper me-2">
              <svg class="check-icon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="10" fill="#228BE6" />
                <path d="M7 12.5l3 3.2 7-7" stroke="white" stroke-width="2" fill="none" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </span>
            Use tools like Criteria, SHL, or internal case studies and scenario-based simulations
          </li>
          <li class="d-flex align-items-start mb-2 global_section_content">
            <span class="icon-wrapper me-2">
              <svg class="check-icon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="10" fill="#228BE6" />
                <path d="M7 12.5l3 3.2 7-7" stroke="white" stroke-width="2" fill="none" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </span>
            Apply these assessments selectively for senior, sensitive, or strategic roles
          </li>
          <li class="d-flex align-items-start mb-2 global_section_content">
            <span class="icon-wrapper me-2">
              <svg class="check-icon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="10" fill="#228BE6" />
                <path d="M7 12.5l3 3.2 7-7" stroke="white" stroke-width="2" fill="none" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </span>
            Deliver consolidated scoring reports alongside expert interpretation
          </li>
        </ul>
      </div>

    </div>
  </div>
</div>

<!-- Onboarding & Client Feedback Loop -->
<div class="" id="Final">
  <div class="container-fluid textmedia-padding px-2 px-md-4 px-lg-5 px-xl-0">
    <div class="row g-0 align-items-center  overflow-hidden flex-row-reverse py-3 py-lg-5">
      <div class="col-lg-5 col-xl-4
 d-flex justify-content-center">
        <div class="image-section" (mouseenter)="hover7 = true" (mouseleave)="hover7 = false">
          <img src="../../../assets/images/staffing-process/image (18).jpg"
            class="img-fluid w-100 h-100 object-fit-cover" alt="Team working" />

          <div class="overlay" [ngClass]="{ 'show': hover7 }"></div>
          <div class="overlay-text img_text" [ngClass]="{ 'show': hover7 }">
            We handle the final steps-so top talent moves from interview to offer without friction. </div>
        </div>
      </div>

      <!-- Text section -->
      <div class="col-lg-7 col-xl-8 pt-3 ps-0 py-lg-3 pe-lg-5 ">
        <div class=" mb-4 mt-2 h2 text_head">Final Interview Coordination & Offer Management </div>
        <p class="global_section_content mb-2">
          From scheduling to salary discussions, we make the last stretch smooth and aligned. Our team manages
          expectations on both sides to ensure fast turnarounds, clear communication, and candidates who are excited to
          accept.
        </p>
        <ul class="list-unstyled mt-3 custom-list">
          <li class="d-flex align-items-start mb-2 global_section_content">
            <span class="icon-wrapper me-2">
              <svg class="check-icon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="10" fill="#228BE6" />
                <path d="M7 12.5l3 3.2 7-7" stroke="white" stroke-width="2" fill="none" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </span>
            Schedule final rounds with client interviewers
          </li>
          <li class="d-flex align-items-start mb-2 global_section_content">
            <span class="icon-wrapper me-2">
              <svg class="check-icon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="10" fill="#228BE6" />
                <path d="M7 12.5l3 3.2 7-7" stroke="white" stroke-width="2" fill="none" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </span>
            Gather structured feedback from both parties
          </li>
          <li class="d-flex align-items-start mb-2 global_section_content">
            <span class="icon-wrapper me-2">
              <svg class="check-icon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="10" fill="#228BE6" />
                <path d="M7 12.5l3 3.2 7-7" stroke="white" stroke-width="2" fill="none" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </span>
            Facilitate transparent salary and notice period discussions
          </li>
          <li class="d-flex align-items-start mb-2 global_section_content">
            <span class="icon-wrapper me-2">
              <svg class="check-icon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="10" fill="#228BE6" />
                <path d="M7 12.5l3 3.2 7-7" stroke="white" stroke-width="2" fill="none" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </span>
            Manage counteroffers and negotiate on your behalf
          </li>
          <li class="d-flex align-items-start mb-2 global_section_content">
            <span class="icon-wrapper me-2">
              <svg class="check-icon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="10" fill="#228BE6" />
                <path d="M7 12.5l3 3.2 7-7" stroke="white" stroke-width="2" fill="none" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </span>
            Prepare and issue offer letter with all legal documentation support
          </li>
        </ul>
      </div>

    </div>
  </div>
</div>

<div class="bg_color position-relative " id="Onboarding">
  <div class="container-fluid textmedia-padding px-2 px-md-4 px-lg-5 px-xl-0">
    <div class="row g-0 align-items-center  overflow-hidden py-3 py-lg-5">
      <!-- Image with Overlay -->
      <div class="col-lg-5 col-xl-4
 d-flex justify-content-center">
        <div class="image-section" (mouseenter)="hover8 = true" (mouseleave)="hover8 = false">
          <img src="../../../assets/images/staffing-process/jobaspirant-shaking-hands.jpg"
            class="img-fluid w-100 h-100 object-fit-cover" alt="Team working" style="object-position: 68%;" />

          <!-- Overlay and Text inside image -->
          <div class="overlay" [ngClass]="{ 'show': hover8 }"></div>
          <div class="overlay-text img_text" [ngClass]="{ 'show': hover8 }">
            We ensure a confident start with structured onboarding and proactive check-ins. </div>
        </div>
      </div>

      <!-- Text section -->
      <div class="col-lg-7 col-xl-8 pt-3 p-lg-3 ps-lg-5 bg-light">
        <div class=" mb-4 mt-1 h2 text_head">Onboarding & Client Feedback Loop</div>
        <p class="global_section_content mb-2">
          We coordinate onboarding logistics, confirm readiness, and follow up at 1, 2, and 4 weeks with both the client and the candidate. Early feedback allows us to fine-tune the fit and address any issues quickly, helping your new hire ramp up efficiently and start strong.
        </p>
        <ul class="list-unstyled mt-3 custom-list">
          <li class="d-flex align-items-start mb-2 global_section_content">
            <span class="text-primary me-2">
              <svg class="check-icon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="10" fill="#228BE6" />
                <path d="M7 12.5l3 3.2 7-7" stroke="white" stroke-width="2" fill="none" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </span>
            Ensure Day 1 readiness: systems access, orientation materials, joining confirmation
          </li>
          <li class="d-flex align-items-start mb-2 global_section_content">
            <span class="text-primary me-2">
              <svg class="check-icon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="10" fill="#228BE6" />
                <path d="M7 12.5l3 3.2 7-7" stroke="white" stroke-width="2" fill="none" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </span>
            Follow up with consultant and client at 1, 2, and 4 weeks
          </li>
          <li class="d-flex align-items-start mb-2 global_section_content">
            <span class="text-primary me-2">
              <svg class="check-icon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="10" fill="#228BE6" />
                <path d="M7 12.5l3 3.2 7-7" stroke="white" stroke-width="2" fill="none" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </span>
            Capture performance feedback and address adjustment needs
          </li>
          <li class="d-flex align-items-start mb-2 global_section_content">
            <span class="text-primary me-2">
              <svg class="check-icon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="10" fill="#228BE6" />
                <path d="M7 12.5l3 3.2 7-7" stroke="white" stroke-width="2" fill="none" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </span>
            Provide replacement options or upskill support if necessary
          </li>
        </ul>
      </div>

    </div>
  </div>
</div>












<div class="why-choose-container text-center position-relative " id="whychoose">
  <h2 class="why-choose-heading p-3 text_head">Why Choose Maganti IT Resources</h2>
  <p class="global_section_content">
  Our staffing model is not just fast, it is strategic. Every step is designed to reduce friction, improve fit, and help you build high performance teams without delay or compromise.
  </p>
</div>




<div class="container-fluid py-2 py-lg-2 feature-section">
  <div class="row g-0 justify-content-center px-2 px-lg-5">

    <!-- Card 1 -->
    <div class="col-lg-4 col-md-6 d-flex align-items-stretch px-2 px-lg-3 py-2 py-lg-4">
      <div class="feature-card card1 w-100 h-100 d-flex  p-4 rounded position-relative overflow-hidden flex-column">
        <div class="d-flex align-items-start">
          <div class="icon-box"></div>
          <div class="ms-3">
            <h2 class="fw-semibold mb-0 cardcolor">Qualified Talent Delivered in 24 Hours</h2>
          </div>
        </div>
        <div class="pt-3">
          <p class="mb-0  text_1">
           Pre-vetted professionals delivered quickly, so your work stays on track.
          </p>
        </div>
      </div>
    </div>

    <!-- Card 2 -->
    <div class="col-lg-4 col-md-6 d-flex align-items-stretch px-2 px-lg-3 py-2 py-lg-4">
      <div class="feature-card card2 w-100 h-100 d-flex  p-4 rounded position-relative overflow-hidden flex-column">
        <div class="d-flex align-items-start">
          <div class="icon-box"></div>
          <div class="ms-3">
            <h2 class="fw-semibold mb-0 cardcolor">Deep Vetting for Risk-Free Hiring</h2>
          </div>
        </div>
        <div class="pt-3">
          <p class="mb-0 text_1">
             Every hire is background checked, fully compliant, and ready to perform.

          </p>
        </div>
      </div>
    </div>

    <!-- Card 3 -->
    <div class="col-lg-4 col-md-6 d-flex align-items-stretch px-2 px-lg-3 py-2 py-lg-4">
      <div class="feature-card card3 w-100 h-100 d-flex  p-4 rounded position-relative overflow-hidden flex-column">
        <div class="d-flex align-items-start">
          <div class="icon-box"></div>
          <div class="ms-3">
            <h2 class="fw-semibold mb-0 cardcolor">Role-Specific Assessments for Precision Fit</h2>
          </div>
        </div>
        <div class="pt-3">
          <p class="mb-0 text_1">
           We match beyond skills, using assessments tailored to your team and culture.
          </p>
        </div>
      </div>
    </div>

    <!-- Card 4 -->
    <div class="col-lg-4 col-md-6 d-flex align-items-stretch px-2 px-lg-3 py-2 py-lg-4">
      <div class="feature-card card4 w-100 h-100 d-flex  p-4 rounded position-relative overflow-hidden flex-column">
        <div class="d-flex align-items-start">
          <div class="icon-box"></div>
          <div class="ms-3">
            <h2 class="fw-semibold mb-0 cardcolor">Clear Communication from Day One to Day Done</h2>
          </div>
        </div>
        <div class="pt-3">
          <p class="mb-0 text_1">
             You receive timely updates, fast responses, and complete transparency throughout the process.
          </p>
        </div>
      </div>
    </div>

    <!-- Card 5 -->
    <div class="col-lg-4 col-md-6 d-flex align-items-stretch px-2 px-lg-3 py-2 py-lg-4">
      <div class="feature-card card5 w-100 h-100 d-flex  p-4 rounded position-relative overflow-hidden flex-column">
        <div class="d-flex align-items-start">
          <div class="icon-box"></div>
          <div class="ms-3">
            <h2 class="fw-semibold mb-0 cardcolor">Onboarding That Accelerates Time-to-Impact</h2>
          </div>
        </div>
        <div class="pt-3">
          <p class="mb-0 text_1">
             We support new hires from day one to ensure they ramp up quickly and start delivering results faster. </p>
        </div>
      </div>
    </div>

  </div>
</div>


<section class="py-5 bg-light">
  <div class="container" id="faq">
    <div class="text-center h2 mb-5 fw-bold">Frequently Asked Questions</div>

    <div class="accordion" id="faqAccordion">

      <div class="row justify-content-center g-0">

        <div class="col-12 col-lg-9">

          <!-- Item 1 -->
          <div class="accordion-item mb-3 shadow-sm border-0 rounded">
            <h2 class="accordion-header" id="headingOne">
              <button class="accordion-button collapsed fw-semibold" type="button" data-bs-toggle="collapse"
                data-bs-target="#collapseOne" aria-expanded="false" aria-controls="collapseOne">
                How quickly can you deliver candidates?
              </button>
            </h2>
            <div id="collapseOne" class="accordion-collapse collapse" data-bs-parent="#faqAccordion">
              <div class="accordion-body">
                We typically deliver the first shortlist of qualified, pre-screened candidates within 24–48 hours.
              </div>
            </div>
          </div>

          <!-- Item 2 -->
          <div class="accordion-item mb-3 shadow-sm border-0 rounded">
            <h2 class="accordion-header" id="headingTwo">
              <button class="accordion-button collapsed fw-semibold" type="button" data-bs-toggle="collapse"
                data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                What is your vetting process for candidates?
              </button>
            </h2>
            <div id="collapseTwo" class="accordion-collapse collapse" data-bs-parent="#faqAccordion">
              <div class="accordion-body">
                Screening includes eligibility verification, skill assessments, background checks, and onboarding steps.
              </div>
            </div>
          </div>

          <!-- Item 3 -->
          <div class="accordion-item mb-3 shadow-sm border-0 rounded">
            <h2 class="accordion-header" id="headingThree">
              <button class="accordion-button collapsed fw-semibold" type="button" data-bs-toggle="collapse"
                data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                How do you handle onboarding?
              </button>
            </h2>
            <div id="collapseThree" class="accordion-collapse collapse" data-bs-parent="#faqAccordion">
              <div class="accordion-body">
                We ensure each hire aligns with your team's communication style, time zone, and dynamics.
              </div>
            </div>
          </div>

          <!-- Item 4 -->
          <div class="accordion-item mb-3 shadow-sm border-0 rounded">
            <h2 class="accordion-header" id="headingFour">
              <button class="accordion-button collapsed fw-semibold" type="button" data-bs-toggle="collapse"
                data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                What happens if a consultant isn’t the right fit?
              </button>
            </h2>
            <div id="collapseFour" class="accordion-collapse collapse" data-bs-parent="#faqAccordion">
              <div class="accordion-body">
                We offer a no-cost replacement within a defined guarantee period and act quickly to find the right
                match.
              </div>
            </div>
          </div>

          <!-- Item 5 -->
          <div class="accordion-item mb-3 shadow-sm border-0 rounded">
            <h2 class="accordion-header" id="headingFive">
              <button class="accordion-button collapsed fw-semibold" type="button" data-bs-toggle="collapse"
                data-bs-target="#collapseFive" aria-expanded="false" aria-controls="collapseFive">
                Can we interview the candidates you submit?
              </button>
            </h2>
            <div id="collapseFive" class="accordion-collapse collapse" data-bs-parent="#faqAccordion">
              <div class="accordion-body">
                While we can manage the entire hiring process on your behalf—so you don’t have to worry about sourcing, screening, or scheduling.  
              </div>
            </div>
          </div>

          <!-- Item 6 -->
          <div class="accordion-item mb-3 shadow-sm border-0 rounded">
            <h2 class="accordion-header" id="headingSix">
              <button class="accordion-button collapsed fw-semibold" type="button" data-bs-toggle="collapse"
                data-bs-target="#collapseSix" aria-expanded="false" aria-controls="collapseSix">
                Do you support remote, hybrid, and on-site models?
              </button>
            </h2>
            <div id="collapseSix" class="accordion-collapse collapse" data-bs-parent="#faqAccordion">
              <div class="accordion-body">
                Yes. Our talent pool supports remote, hybrid, and on-site models based on your project needs.
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</section>